<template>
  <div id="sharkbetMyAccount" class="modal fade sharkbet-profile-modal" tabindex="-1" aria-labelledby="sharkbetMyAccountLabel" aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button type="button" class="sharkbet-profile-modal__close" data-bs-dismiss="modal" aria-label="Cerrar">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
        <div class="modal-body">
          <div class="sharkbet-profile-modal__sidebar-column">
            <nav class="sharkbet-profile-modal__sidebar" aria-label="Menu de cuenta">
              <button type="button" :class="{ 'is-active': activeSection === 'account' }" @click="activeSection = 'account'"><i class="fas fa-user-circle" aria-hidden="true"></i> Mi cuenta</button>
              <button type="button" :class="{ 'is-active': activeSection === 'history' }" @click="openHistory"><i class="fas fa-history" aria-hidden="true"></i> Historial de Juego</button>
              <button type="button" :class="{ 'is-active': activeSection === 'transactions' }" @click="activeSection = 'transactions'"><i class="fas fa-list" aria-hidden="true"></i> Transacciones</button>
              <button type="button" :class="{ 'is-active': activeSection === 'bonuses' }" @click="activeSection = 'bonuses'"><i class="fas fa-money-bill-wave" aria-hidden="true"></i> Mis Bonificaciones</button>
              <button type="button" :class="{ 'is-active': activeSection === 'password' }" @click="activeSection = 'password'"><i class="fas fa-key" aria-hidden="true"></i> Modificar contraseña</button>
              <button type="button" :class="{ 'is-active': activeSection === 'incomeHistory' }" @click="activeSection = 'incomeHistory'"><i class="fas fa-chart-bar" aria-hidden="true"></i> Historial de ingresos</button>
            </nav>
          </div>

          <div class="sharkbet-profile-modal__content">
            <template v-if="activeSection === 'account'">
              <h2 id="sharkbetMyAccountLabel">MI CUENTA</h2>

              <section class="sharkbet-profile-modal__group sharkbet-profile-modal__group--details">
              <label>Primer nombre *<input :value="profile.name || profile.first_name || profile.nombre || ''" readonly></label>
              <label>Apellido *<input :value="profile.last_name || profile.lastname || profile.apellidos || ''" readonly></label>
              <label>Correo electronico *<span class="sharkbet-profile-modal__verified"><input :value="profile.email || ''" readonly><b><i class="fas fa-check"></i> Verificado</b></span></label>
              <label>Numero de telefono *<input :value="profile.phone || profile.phone_number || ''" readonly></label>
              <label>Fecha de nacimiento *<input :value="profile.birth_date || profile.birthday || profile.birthDay || ''" readonly></label>
              <label>Documento de identidad *<input :value="profile.document || profile.document_number || profile.idn || profile.cedula || ''" readonly></label>
              </section>

              <section class="sharkbet-profile-modal__group sharkbet-profile-modal__group--address">
              <label>Pais<input :value="profile.country || ''" readonly></label>
              <label>Ciudad *<input :value="profile.city || ''" readonly></label>
              <label>Codigo postal *<input :value="profile.postal_code || profile.postalCode || ''" readonly></label>
              <label class="sharkbet-profile-modal__address">Direccion *<input :value="profile.address || profile.direccion || ''" readonly></label>
              </section>

              <label class="sharkbet-profile-modal__newsletter"><input type="checkbox" :checked="Boolean(profile.newsletter)" disabled> Quiero recibir novedades por email</label>

              <div class="sharkbet-profile-modal__actions">
                <button type="button" :disabled="refreshing" @click="refreshProfile">{{ refreshing ? 'Actualizando' : 'Actualizar' }}</button>
                <button type="button" data-bs-dismiss="modal">Cerrar</button>
              </div>
            </template>

            <form v-else-if="activeSection === 'password'" class="sharkbet-profile-modal__password" @submit.prevent="changePassword">
              <h2 id="sharkbetMyAccountLabel">CAMBIAR CONTRASEÑA</h2>
              <label>Contraseña actual *
                <span class="sharkbet-profile-modal__password-input">
                  <i class="fas fa-lock" aria-hidden="true"></i>
                  <input v-model="currentPassword" :type="showCurrentPassword ? 'text' : 'password'" autocomplete="current-password">
                  <button type="button" aria-label="Mostrar contraseña actual" @click="showCurrentPassword = !showCurrentPassword"><i :class="showCurrentPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i></button>
                </span>
              </label>
              <label>Nueva contraseña *
                <span class="sharkbet-profile-modal__password-input">
                  <i class="fas fa-lock" aria-hidden="true"></i>
                  <input v-model="newPassword" :type="showNewPassword ? 'text' : 'password'" autocomplete="new-password">
                  <i class="fas fa-info-circle sharkbet-profile-modal__password-help" title="Usa una contraseña segura" aria-hidden="true"></i>
                  <button type="button" aria-label="Mostrar nueva contraseña" @click="showNewPassword = !showNewPassword"><i :class="showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i></button>
                </span>
              </label>
              <label>Repetir contraseña *
                <span class="sharkbet-profile-modal__password-input">
                  <i class="fas fa-lock" aria-hidden="true"></i>
                  <input v-model="repeatPassword" :type="showRepeatPassword ? 'text' : 'password'" autocomplete="new-password">
                  <i class="fas fa-info-circle sharkbet-profile-modal__password-help" title="Repite la nueva contraseña" aria-hidden="true"></i>
                  <button type="button" aria-label="Mostrar confirmación de contraseña" @click="showRepeatPassword = !showRepeatPassword"><i :class="showRepeatPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i></button>
                </span>
              </label>
              <div class="sharkbet-profile-modal__password-actions">
                <button type="submit" :disabled="changingPassword || !canChangePassword">{{ changingPassword ? 'Cambiando contraseña' : 'Cambiar contraseña' }}</button>
                <button type="button" data-bs-dismiss="modal">Cerrar</button>
              </div>
              <p v-if="passwordStatus.message" :class="`sharkbet-profile-modal__password-status is-${passwordStatus.type}`">{{ passwordStatus.message }}</p>
            </form>

            <game-history v-else-if="activeSection === 'history'" :auto-load="true" />
            <income-history v-else-if="activeSection === 'incomeHistory'" :auto-load="true" />
            <transactions v-else-if="activeSection === 'transactions'" />
            <bonuses v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Bonuses from './bonuses.vue';
import GameHistory from './game_history.vue';
import IncomeHistory from './income_history.vue';
import Transactions from './transactions.vue';

export default {
  name: 'SharkbetMyAccount',
  props: ['skin'],
  components: { Bonuses, GameHistory, IncomeHistory, Transactions },
  data() {
    return {
      activeSection: 'account',
      changingPassword: false,
      currentPassword: '',
      newPassword: '',
      passwordStatus: { message: '', type: '' },
      refreshing: false,
      repeatPassword: '',
      showCurrentPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
    };
  },
  computed: {
    user() { return this.$store.getters['getUserData']; },
    profile() { return this.user.user_data?.data || {}; },
    apiUrl() { return this.$store.getters['getApiUrlnew']; },
    canChangePassword() { return Boolean(this.currentPassword && this.newPassword && this.repeatPassword); },
  },
  methods: {
    async changePassword() {
      if (this.newPassword !== this.repeatPassword) {
        this.passwordStatus = { message: 'Las contraseñas no coinciden', type: 'error' };
        return;
      }

      this.changingPassword = true;
      this.passwordStatus = { message: '', type: '' };
      try {
        const id = this.profile.user_id ?? this.profile.id;
        const response = await axios.post(`${this.apiUrl}user/cambiar_password`, {
          users: [id],
          password: this.newPassword,
          password1: this.repeatPassword,
          login_id: id,
        }, {
          headers: { 'x-player-token': this.user.token, 'x-api-key': 'FTBBW4bR1pKTUFsURbFD8RpcPygh8wN6' },
        });
        if (response.data.error) {
          this.passwordStatus = { message: response.data.error, type: 'error' };
        } else {
          this.passwordStatus = { message: response.data.message, type: 'success' };
          this.$store.dispatch('logOut');
          this.$root.$emit('forceRender');
        }
      } catch (error) {
        this.passwordStatus = { message: error.response?.data?.error || 'Error', type: 'error' };
      } finally {
        this.changingPassword = false;
      }
    },
    openHistory() {
      this.activeSection = 'history';
    },
    async refreshProfile() {
      if (!this.user.token || this.refreshing) return;

      this.refreshing = true;
      await this.$store.dispatch('getProfile', {
        token: this.user.token,
        site_id: this.user.site_id,
        site: this.user.site,
        prefix: this.user.prefix,
        playerId: this.profile.user_id,
        source: 'main',
      });
      this.refreshing = false;
    },
  },
};
</script>

<style scoped>
.sharkbet-profile-modal {
  background: rgba(0, 0, 32, .78);
}

.sharkbet-profile-modal .modal-dialog {
  max-width: 1180px;
}

.sharkbet-profile-modal .modal-content {
  background: transparent;
  border: 0;
  color: #17212a;
  position: relative;
}

.sharkbet-profile-modal__close {
  align-items: center;
  background: transparent;
  border: 0;
  color: #4d5861;
  cursor: pointer;
  display: flex;
  font-size: 20px;
  height: 36px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 12px;
  top: 10px;
  width: 36px;
  z-index: 2;
}

.sharkbet-profile-modal__close:hover {
  color: #17212a;
}

.sharkbet-profile-modal .modal-body {
  display: grid;
  gap: 0;
  grid-template-columns: 266px minmax(0, 1fr);
  padding: 0;
}

.sharkbet-profile-modal__sidebar-column {
  align-self: stretch;
  background: #fff;
  border-radius: 0 0 0 12px;
  height: 320px;
  margin-top: 20px;
  padding: 12px;
  position: relative;
}

.sharkbet-profile-modal__sidebar-column::before {
  background: #fff;
  border-radius: 12px 0 0 0;
  content: '';
  height: 20px;
  left: 0;
  position: absolute;
  right: 0;
  top: -20px;
}

.sharkbet-profile-modal__sidebar {
  align-content: start;
  background: #ececec;
  border-radius: 0 0 6px 6px;
  display: grid;
}

.sharkbet-profile-modal__sidebar > * {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #fff;
  color: #17212a;
  display: flex;
  font: 600 16px 'Roboto', sans-serif;
  gap: 9px;
  text-align: left;
  min-height: 49px;
  padding: 10px 9px;
}

.sharkbet-profile-modal__sidebar > *:last-child {
  border-bottom: 0;
  border-radius: 0 0 12px 12px;
}

.sharkbet-profile-modal__sidebar > *.is-active {
  background: #e4e4e4;
}

.sharkbet-profile-modal__sidebar button {
  cursor: pointer;
}

.sharkbet-profile-modal__sidebar i {
  color: #303030;
  font-size: 16px;
  text-align: center;
  width: 15px;
}

.sharkbet-profile-modal__content {
  background: #fff;
  border-radius: 0 12px 12px 12px;
  min-width: 0;
  padding: 26px 24px;
}

.sharkbet-profile-modal__password {
  display: grid;
  gap: 26px;
  max-width: 100%;
}

.sharkbet-profile-modal__password h2 {
  margin-bottom: 30px;
}

.sharkbet-profile-modal__password label {
  gap: 6px;
}

.sharkbet-profile-modal__password-input {
  align-items: center;
  border: 1px solid #c8c8c8;
  border-radius: 22px;
  display: flex;
  height: 40px;
  padding: 0 12px;
}

.sharkbet-profile-modal__password-input:focus-within {
  border-color: #009fe3;
}

.sharkbet-profile-modal__password-input > i {
  color: #777;
  flex: 0 0 18px;
  text-align: center;
}

.sharkbet-profile-modal__password-input input {
  border: 0;
  height: 38px;
  outline: 0;
  padding: 0 10px;
}

.sharkbet-profile-modal__password-input button {
  background: transparent;
  border: 0;
  color: #777;
  cursor: pointer;
  padding: 0 2px;
}

.sharkbet-profile-modal__password-input button i {
  font-size: 18px;
}

.sharkbet-profile-modal__password-help {
  margin-left: auto;
}

.sharkbet-profile-modal__password-actions {
  display: grid;
  gap: 32px;
  grid-template-columns: 1fr 1fr;
  margin-top: 4px;
}

.sharkbet-profile-modal__password-actions button {
  border-radius: 22px;
  cursor: pointer;
  font: 600 14px 'Roboto', sans-serif;
  height: 37px;
}

.sharkbet-profile-modal__password-actions button[type='submit'] {
  background: #0092cd;
  border: 0;
  color: #fff;
}

.sharkbet-profile-modal__password-actions button[type='submit']:disabled {
  background: #dedede;
  color: #a4a4a4;
  cursor: not-allowed;
}

.sharkbet-profile-modal__password-actions button[type='button'] {
  background: #fff;
  border: 1px solid #009fe3;
  color: #008ccd;
}

.sharkbet-profile-modal__password-status {
  font: 14px 'Roboto', sans-serif;
  margin: -12px 0 0;
}

.sharkbet-profile-modal__password-status.is-error {
  color: #d63031;
}

.sharkbet-profile-modal__password-status.is-success {
  color: #159b55;
}

.sharkbet-profile-modal h2 {
  font: 400 30px 'Roboto', sans-serif;
  margin: 0 0 22px;
}

.sharkbet-profile-modal__group {
  background: #f6f6f6;
  border-radius: 10px;
  display: grid;
  gap: 12px 16px;
  margin-bottom: 10px;
  padding: 12px;
}

.sharkbet-profile-modal__group--details {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.sharkbet-profile-modal__group--address {
  grid-template-columns: 1fr 1.05fr 1fr;
}

.sharkbet-profile-modal label {
  display: grid;
  font: 500 16px 'Roboto', sans-serif;
  gap: 6px;
}

.sharkbet-profile-modal input {
  background: #fff;
  border: 1px solid #c8c8c8;
  border-radius: 22px;
  color: #5f6972;
  font: 15px 'Roboto', sans-serif;
  height: 40px;
  min-width: 0;
  padding: 0 12px;
  width: 100%;
}

.sharkbet-profile-modal__verified {
  align-items: center;
  display: flex;
  gap: 8px;
}

.sharkbet-profile-modal__verified b {
  align-items: center;
  background: #32dc7d;
  border-radius: 22px;
  color: #fff;
  display: flex;
  flex: 0 0 auto;
  font: 600 13px 'Roboto', sans-serif;
  gap: 5px;
  height: 40px;
  padding: 0 13px;
}

.sharkbet-profile-modal__address {
  grid-column: 1 / -1;
}

.sharkbet-profile-modal__newsletter {
  align-items: center;
  display: flex !important;
  gap: 10px !important;
  margin: 15px 0 28px;
}

.sharkbet-profile-modal__newsletter input {
  accent-color: #0092cd;
  height: 19px;
  width: 19px;
}

.sharkbet-profile-modal__actions {
  display: flex;
  gap: 12px;
}

.sharkbet-profile-modal__actions button {
  border: 0;
  border-radius: 22px;
  cursor: pointer;
  font: 600 15px 'Roboto', sans-serif;
  height: 38px;
  min-width: 160px;
  padding: 0 24px;
}

.sharkbet-profile-modal__actions button:first-child {
  background: #0092cd;
  color: #fff;
}

.sharkbet-profile-modal__actions button:first-child:disabled {
  cursor: wait;
  opacity: .7;
}

.sharkbet-profile-modal__actions button:last-child {
  background: #e6e6e6;
  color: #29313a;
}

@media (max-width: 767px) {
  .sharkbet-profile-modal .modal-dialog {
    margin: 10px;
  }

  .sharkbet-profile-modal .modal-content {
    background: #fff;
    border-radius: 12px;
  }

  .sharkbet-profile-modal .modal-body {
    display: block;
    padding: 22px 18px;
  }

  .sharkbet-profile-modal__sidebar-column {
    display: none;
  }

  .sharkbet-profile-modal__content {
    background: transparent;
    border-radius: 0;
    padding: 0;
    padding-right: 0;
  }

  .sharkbet-profile-modal__password {
    gap: 22px;
  }

  .sharkbet-profile-modal__password h2 {
    margin-bottom: 20px;
  }

  .sharkbet-profile-modal__group--details,
  .sharkbet-profile-modal__group--address {
    grid-template-columns: 1fr;
  }

  .sharkbet-profile-modal__actions button {
    min-width: 0;
    width: 50%;
  }
}
</style>
